export class BrandingColors {
  primary: string;
  secondary: string;
  highlight: string;
  success: string;
  warning: string;
  info: string;
  danger: string;

  constructor() {
    this.primary = '';
    this.secondary = '';
    this.highlight = '';
    this.success = '';
    this.warning = '';
    this.info = '';
    this.danger = '';
  }
}
